(function (Drupal) {
  'use strict';

  Drupal.behaviors.video_modal = {
    attach: function (context, settings) {
      // Prevent duplicate execution on AJAX contexts
      if (context.__videoModalInitDone) return;
      context.__videoModalInitDone = true;

      // Defer all logic until full page load
      const runWhenReady = (fn) => {
        if (document.readyState === 'complete') {
          if ('requestIdleCallback' in window) {
            requestIdleCallback(fn, { timeout: 300 });
          } else {
            setTimeout(fn, 100); // Fallback
          }
        } else {
          window.addEventListener('load', () => {
            if ('requestIdleCallback' in window) {
              requestIdleCallback(fn, { timeout: 300 });
            } else {
              setTimeout(fn, 100);
            }
          });
        }
      };

      runWhenReady(() => {
        const videoMaxWidth = 700;
        let videoResizeTO = null;

        const qs = (sel, scope = document) => scope.querySelector(sel);
        const qsa = (sel, scope = document) => [...scope.querySelectorAll(sel)];

        const sizeVideoFrame = (iframe, height, width) => {
          const maxW = Math.min(videoMaxWidth, window.innerWidth);
          let h = height * (maxW / width);
          const headerHeight = qs('.global-header')?.offsetHeight || 0;
          const winHeight = window.innerHeight - headerHeight;

          if (h > (winHeight - 64)) {
            h = winHeight - 64;
            width = width * (h / height);
          }

          iframe.setAttribute('height', Math.floor(h));
          iframe.setAttribute('width', Math.floor(width));
        };

        const sizeVideoOverlay = (overlay) => {
          const headerHeight = qs('.global-header')?.offsetHeight || 0;
          overlay.style.top = `${headerHeight}px`;
          overlay.style.height = `calc(100vh - ${headerHeight}px)`;
        };

        const buttonLoadVideo = (btn) => {
          const src = btn.getAttribute('data-src');
          const title = btn.getAttribute('data-title');
          const width = parseInt(btn.getAttribute('width'), 10) || 1280;
          const height = parseInt(btn.getAttribute('height'), 10) || 720;

          const iframe = document.createElement('iframe');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('title', title);
          iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
          iframe.setAttribute('src', `${src}${src.includes('?') ? '&' : '?'}autoplay=1`);

          const overlay = document.createElement('div');
          overlay.className = 'video-player-overlay';

          const videoWrap = document.createElement('div');
          videoWrap.className = 'video-wrap';
          if (window.innerWidth < videoMaxWidth) {
            videoWrap.classList.add('full-width');
          }

          const dismissBtn = document.createElement('div');
          dismissBtn.className = 'video-dismiss';
          dismissBtn.innerHTML = `<a href="#">X</a>`;
          dismissBtn.addEventListener('click', (e) => {
            e.preventDefault();
            overlay.remove();
            document.documentElement.classList.remove('no-scroll');
          });

          overlay.addEventListener('click', () => {
            overlay.remove();
            document.documentElement.classList.remove('no-scroll');
          });

          const focusEnd = document.createElement('a');
          focusEnd.setAttribute('href', '#');

          videoWrap.appendChild(dismissBtn);
          videoWrap.appendChild(iframe);
          videoWrap.appendChild(focusEnd);
          overlay.appendChild(videoWrap);
          const mount = document.getElementById('content') || document.body;
          mount.appendChild(overlay);
          document.documentElement.classList.add('no-scroll');

          sizeVideoFrame(iframe, height, width);
          sizeVideoOverlay(overlay);

          window.addEventListener('resize', () => {
            if (videoResizeTO) clearTimeout(videoResizeTO);
            videoResizeTO = setTimeout(() => {
              sizeVideoFrame(iframe, height, width);
              sizeVideoOverlay(overlay);
            }, 50);
          });

          focusTrap(overlay);
          iframe.focus();
        };

        const focusTrap = (modal) => {
          const focusables = modal.querySelectorAll('a, button');
          const first = focusables[0];
          const last = focusables[focusables.length - 1];

          first?.focus();

          modal.addEventListener('keydown', (e) => {
            if (e.key === 'Tab') {
              if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
              } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
              }
            }
          });
        };

        const videoInit = () => {
          const headerVideoBtn = qs('.field--name-field-header-image .remote-video-button');
          if (headerVideoBtn) {
            qsa('.watch-video').forEach((btn) => {
              btn.setAttribute('data-src', headerVideoBtn.getAttribute('data-src'));
              btn.setAttribute('data-title', headerVideoBtn.getAttribute('data-title'));
            });
          }

          qsa('.remote-video-button, .watch-video').forEach((btn) => {
            if (btn.dataset.videoModalBound) {
              return;
            }
            btn.dataset.videoModalBound = 'true';
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              buttonLoadVideo(btn);
            });
          });

          qsa('.transcript-button').forEach((btn) => {
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              const box = btn.closest('.transcript-container')?.querySelector('.transcript-box');
              if (!box) return;
              box.classList.toggle('hide');
              btn.innerHTML = box.classList.contains('hide') ? 'Show Video Transcript' : 'Hide Video Transcript';
            });
          });

          const hero = qs('.field--name-field-header-image .unicef-remote-video .video-wrapper.hero');
          if (hero) {
            const title = qs('.field--name-title')?.textContent;
            const headline = qs('.field--name-field-header-image .field--name-field-headline');
            if (title && headline) {
              headline.textContent = title;
            }
          }

          const transcript = qs('.field--name-field-header-image .video-transcript');
          const heroWrap = qs('.hero-basic-content-wrap');
          if (transcript && heroWrap) {
            heroWrap.insertAdjacentElement('afterend', transcript);
          }
        };

        videoInit(); // 🔁 Only runs after full page load
      });
    }
  };
})(Drupal);
